export enum RightType {
  Acquisition = "Acquisition",
  Disposal = "Disposal",
  All = "All",
}
